import { AnyAction } from "@reduxjs/toolkit";
import _get from "lodash/get";
import * as AT from "./actionTypes";
import { PickupPointState } from "../../../../models/state";
import { fulfilled, pending } from "../../app/utils";
import * as CHECKOUT_AT from "../../checkout/state/actionTypes";

const initialState: PickupPointState = {
    points: [],
};

const reducer = (state = initialState, action: AnyAction): PickupPointState => {
    switch (action.type) {
        case pending(AT.PICKUP_POINTS_FETCH_PICKUP_POINTS):
            return {
                ...state,
                points: [],
            };
        case fulfilled(AT.PICKUP_POINTS_FETCH_PICKUP_POINTS):
            return {
                ...state,
                points: _get(action, "payload.points", []),
            };
        case fulfilled(CHECKOUT_AT.CHECKOUT_FETCH_DELIVERY_AND_PAYMENT_METHODS):
            return {
                ...state,
                points: _get(action, "payload.delivery.points", []),
            };
        case fulfilled(CHECKOUT_AT.CHECKOUT_UPDATE_DELIVERY_ADDRESS):
            return {
                ...state,
                points: _get(action, "payload.delivery.points", []),
            };
        default:
            return state;
    }
};

export default reducer;
